import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { EarningReportListResponse } from '../model/response/earning-report-list.response';
import { MonthlyDeliveryIncomeResponse } from '../model/response/monthly-delivery-income.response';
import { MonthlyIncomeRequest } from '../model/request/monthly-income.request';

@Injectable()
export class AdminRecruitmentBonusPaymentsApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchList(page, limit, filter = null) {
    return this.http.get<any>(
      this.prepareListRequest(
        this.baseUrl + '/api/cf/administration/recruitment-bonus/payments',
        page,
        limit,
        [{totalAmount: 'DESC'}],
        filter
      ),
      {headers: this.getAuthHeaders()}
    );
  }
}
